exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form>div>div>label[data-v-da8d9694],form>div>div>span[data-v-da8d9694]{background-color:var(--color-curious-blue,#2286c3);color:var(--color-white,#fff);border-color:var(--color-curious-blue,#2286c3)}form>div>div>span.customized-span[data-v-da8d9694]{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}form>div>input[data-v-da8d9694],form>div>select[data-v-da8d9694]{border-color:var(--color-curious-blue,#2286c3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-da8d9694","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/commandes_livraison/components/Read.vue
// module id = 445
// module chunks = 0